import { createFeatureSelector } from '@ngrx/store';

import * as fromDashboardFilter from '@dashboards/store/reducers/dashboard-filter.reducer';

export const selectDashboardFilterState = createFeatureSelector<fromDashboardFilter.DashboardFilterState>(
  fromDashboardFilter.dashboardFilterFeatureKey
);
